<template>
  <div class="app-side-menu">
    <ul>
      <router-link
        tag="li"
        v-for="menu in menus"
        :key="menu.text"
        :to="{ name: menu.route }"
      >
        <div v-if="menu.submenus" class="submenus">
          <ul>
            <router-link
              tag="li"
              v-for="submenu in menu.submenus"
              :key="submenu.text"
              :to="{ name: submenu.route }"
              >{{ submenu.text }}</router-link
            >
          </ul>
        </div>
        <div class="menu">
          <div class="icon">
            <object type="image/svg+xml" :data="menu.icon" class="logo">
            </object>
          </div>
          <div class="text">{{ menu.text }}</div>
        </div>
      </router-link>
    </ul>

    <img src="@/assets/img/logo_philco.svg" alt="Logo Philco" />
  </div>
</template>

<script>
import { MENUS } from '@/constants/menus.constants';

export default {
  name: 'app-side-menu',
  data: () => {
    return {
      menus: MENUS,
    };
  },
};
</script>

<style lang="scss" scoped>
.app-side-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
  background: linear-gradient(
    178.83deg,
    #fb8c32 0.15%,
    var(--color-primary-light) 129.81%
  );
  width: var(--sidemenu-width);
  padding: 32px 0;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      position: relative;

      &:hover {
        .submenus {
          display: unset;
        }
      }

      .menu {
        display: flex;
        align-items: center;
        text-transform: uppercase;
        font-size: 13px;
        font-weight: 600;
        height: 60px;
        padding-left: 16px;
        transition: background 0.2s ease-in-out;
        cursor: pointer;

        &.active {
          .icon {
            background: #fff;
          }
        }

        &:hover {
          background: rgba(255, 255, 255, 0.4);
        }

        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 32px;
          width: 32px;
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.4);
          margin-right: 12px;
        }
      }

      .submenus {
        display: none;
        position: absolute;
        background: #fff;
        top: 0;
        left: 100%;
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        min-width: 150px;
        z-index: 50;

        &::before {
          content: '';
          position: absolute;
          top: 24px;
          left: -8px;
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          border-right: 8px solid #fff;
          border-bottom: 8px solid transparent;
        }

        &:hover {
          display: unset;

          ~ .menu {
            background: rgba(255, 255, 255, 0.4);
          }
        }

        ul {
          li {
            padding: 16px;
            color: var(--text-color);
            cursor: pointer;
            transition: background 0.2s ease-in-out;

            &:hover {
              font-weight: 600;
              background: rgba(0, 0, 0, 0.02);
            }
          }
        }
      }
    }
  }
}
</style>
